import { render, staticRenderFns } from "./IconEmail.vue?vue&type=template&id=6ecedab6&scoped=true&"
import script from "./IconEmail.vue?vue&type=script&lang=js&"
export * from "./IconEmail.vue?vue&type=script&lang=js&"
import style0 from "./IconEmail.vue?vue&type=style&index=0&id=6ecedab6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecedab6",
  null
  
)

export default component.exports